import { createContext } from "react";

/**
 * When true, MetricChartFrame renders only the chart body — no toolbar, caption
 * or card border — so a chart can be reused as a compact thumbnail preview.
 */
export const ChartPreviewContext = createContext(false);
